import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class LandingHeaderLoaderStateService {
  private readonly loadingSubject = new BehaviorSubject<boolean>(false);
  private isLandingMediaLoading = false;
  private isHeaderDynamicContentLoaded = false;
  readonly loading$ = this.loadingSubject.asObservable();

  private publishLoading(): void {
    const isLoading = this.isLandingMediaLoading || !this.isHeaderDynamicContentLoaded;
    this.loadingSubject.next(isLoading);
  }

  setLandingMediaLoading(isLoading: boolean): void {
    this.isLandingMediaLoading = isLoading;
    this.publishLoading();
  }

  setHeaderDynamicContentLoaded(isLoaded: boolean): void {
    this.isHeaderDynamicContentLoaded = isLoaded;
    this.publishLoading();
  }

  // Backward compatibility for existing callers.
  setLoading(isLoading: boolean): void {
    this.setLandingMediaLoading(isLoading);
  }
}
